import React from "react";
import { motion } from "framer-motion";
import type { ChatHistoryResponse } from "@/types/discuss.types";
import Message from "./Message";

interface ActiveProcessingMessageProps {
  activeProcessingTask: { prompt?: string } | null | undefined;
  historyData: ChatHistoryResponse | undefined;
  lastMessageRef: React.RefObject<HTMLDivElement>;
}

export const ActiveProcessingMessage: React.FC<ActiveProcessingMessageProps> = ({
  activeProcessingTask,
  historyData,
  lastMessageRef,
}) => {
  const prompt = activeProcessingTask?.prompt ?? "Processing...";
  const lastHistoryMessage = historyData?.prev_chat?.[(historyData.prev_chat?.length ?? 0) - 1];
  const isDuplicate = lastHistoryMessage?.question === prompt;

  if (isDuplicate) return null;

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="w-full"
      ref={lastMessageRef}
    >
      <Message type="user" message={prompt} creation_date={new Date().toISOString()} />
    </motion.div>
  );
};
